import  { useEffect, useState } from "react";
import MaterialBox from "../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialInput from "../../../../components/MaterialInput";
import {
  Autocomplete,
  CardContent,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Switch,
  TextField,
} from "@mui/material";
import MaterialButton from "../../../../components/MaterialButton";
import { useNavigate } from "react-router-dom";
import { fetchData } from "../../../../services";
import { useLoading } from "../../../../components/Loading";
import { useSnackbar } from "../../../../context/popup";
import DropDownConfig from "../../../Utils/DropDownConfig";

export const GeneralAddonForm = ({ onsubmit, editAddonData }) => {

  const navigate = useNavigate();
  const { setCircleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();
  const [addonData, setAddonData] = useState({
    // addon information
    name: "",
    description: "",
    autoApply: true,
    mandatory: true,
    // productId: "",
    productId: [],
    policyTypeId: [],
    isActive: true,

    // addon information status
    nameStatus: "unchecked",
    descriptionStatus: "unchecked",
    productIdStatus: "unchecked",
    policyTypeIdStatus: "unchecked",
  });
  const [productOptions, setProductOptions] = useState([]);
  const [policyTypeOptions, setPolicyTypeOptions] = useState([]);

  useEffect(() => {
    if (editAddonData) {
      setAddonData(editAddonData);
    }
  }, [editAddonData]);

   //dropdown apis
   useEffect(() => {
    
     //dropdown apis for form
     const fetchDropdowns = async () => {
       setCircleLoading(true);
       try {
        const [productResponse, policyTypeResponse] = await Promise.all([
          fetchData(`/reference/general/key-value-store?dropdown=true&code=${DropDownConfig?.generalProduct}`),  //code passing for product
          fetchData(`/reference/general/key-value-store?dropdown=true&code=${DropDownConfig?.generalPolicyType}`)  //code passing for policy type
        ]);
 
         if (productResponse?.success) {
           setProductOptions(
             productResponse.data?.items?.map((item) => ({
               value: item.id,
               label: item.keyName,
             })) || []
           );
         }
 
         if (policyTypeResponse?.success) {
           setPolicyTypeOptions(
             policyTypeResponse.data?.items?.map((item) => ({
               value: item.id,
               label: item.keyName,
             })) || []
           );
         }
       } catch (error) {
         console.error("Error fetching dropdown data:", error);
         showSnackbar("Error fetching Dropdown","error");
       } finally {
         setCircleLoading(false);
       }
     };
 
     fetchDropdowns();
   }, []);

  const handleAddonDataChange = (event) => {
    let addonState = { ...addonData };

    const changeAllowed = true;

   if (event && event.target) {
      switch (event.target.name) {
        case "name":
          {
            const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,150})$");

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              addonState[event.target.name + "Status"] = "success";
            } else {
              addonState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "description":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{2,100})$");

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              addonState[event.target.name + "Status"] = "success";
            } else {
              addonState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "autoApply":
          {
            addonState[event.target.name] = event.target.value;
          }
          break;

        case "mandatory":
          {
            addonState[event.target.name] = event.target.value;
          }
          break;

        default:
          break;
      }

      if (changeAllowed) {
        addonState[event.target.name] = event.target.value;
      }
    }
    setAddonData(addonState);
  };

  const handleMultiSelect = (value, name) => {
    let addonState = { ...addonData };

    if (name === "productId") {
      const selectedIds = value.map((item) => item.value);

      addonState.productId = selectedIds;
      addonState.productIdStatus =
        selectedIds.length > 0 ? "success" : "error";
    }

    else if (name === "policyTypeId") {
      const selectedIds = value.map((item) => item.value);

      addonState.policyTypeId = selectedIds;
      addonState.policyTypeIdStatus =
        selectedIds.length > 0 ? "success" : "error";
    }
    else{
      return
    }
    setAddonData(addonState);
  };

  const checkAllFields = () => {
    const isNameValid = addonData.nameStatus === "success";
    const isProductValid = addonData.productId?.length > 0;
    const isPolicyTypeValid = addonData.policyTypeId?.length > 0;

    return isNameValid && isProductValid && isPolicyTypeValid;
  };

  const handleSubmit = () => {
    if (checkAllFields()) {
      onsubmit(addonData);
    }
  };

  return (
    <> 
      <CardContent>
        <MaterialBox>
          <Grid container spacing={1}>

            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Products*
                </MaterialTypography>
              </MaterialBox>
               <Autocomplete
                multiple
                options={productOptions}
                value={productOptions.filter(opt =>
                  addonData.productId.includes(opt.value)
                )}
                ListboxProps={{
                  style: {
                    maxHeight: 220,   //  control height
                    overflowY: "auto"
                  }
                }}
                onChange={(event, newValue) =>
                  handleMultiSelect(newValue, "productId")
                }
                disableCloseOnSelect
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox checked={selected} size="small"/>
                    {option.label}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="medium"
                    placeholder={addonData.productId.length > 0 ? "" : "Select Multiple Products"}
                    error={addonData.productIdStatus === "error"}
                    helperText={
                      addonData.productIdStatus === "error"
                        ? "Please select at least one Product"
                        : ""
                    }
                  />
                )}
              />
              
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Policy Types*
                </MaterialTypography>
              </MaterialBox>
              <Autocomplete
                multiple
                options={policyTypeOptions}
                value={policyTypeOptions.filter(opt =>
                  addonData.policyTypeId.includes(opt.value)
                )}
                ListboxProps={{
                  style: {
                    maxHeight: 220,   //  control height
                    overflowY: "auto"
                  }
                }}
                onChange={(_, newValue) =>
                  handleMultiSelect(newValue, "policyTypeId")
                }
                disableCloseOnSelect
                getOptionLabel={(option) => option.label || ""}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox checked={selected} size="small" />
                    {option.label}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="medium"
                    placeholder={addonData.policyTypeId.length > 0 ? "" :"Select Multiple Policy Types"}
                    error={addonData.policyTypeIdStatus === "error"}
                    helperText={
                      addonData.policyTypeIdStatus === "error"
                        ? "Please select at least one Policy Type"
                        : ""
                    }
                  />
                )}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Addon Name*
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="name"
                placeholder="eg. Engine Cover"
                value={addonData.name}
                onChange={handleAddonDataChange}
                error={addonData.nameStatus === "error" ? true : false}
                success={addonData.nameStatus === "success" ? true : false}
              />
              {addonData.nameStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Name should be between 1 to 150 characters long
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 2 }}>
              <MaterialBox>
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Auto Apply
                </MaterialTypography>
              </MaterialBox>
              <FormControlLabel
                control={
                  <Switch
                    name="autoApply"
                    checked={addonData.autoApply}
                    onChange={(event) =>
                      handleAddonDataChange({
                        target: {
                          name: "autoApply",
                          value: event.target.checked,
                        },
                      })
                    }
                    color="primary"
                  />
                }
                label={
                  <MaterialTypography variant="caption" fontWeight="bold">
                    {addonData?.autoApply ? "Yes" : "No"}
                  </MaterialTypography>
                }
                sx={{ marginLeft: 0 }}
              />
            </Grid>

            <Grid size={{ xs: 6, sm: 2 }}>
              <MaterialBox>
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Mandatory
                </MaterialTypography>
              </MaterialBox>
              <FormControlLabel
                control={
                  <Switch
                    name="mandatory"
                    checked={addonData.mandatory}
                    onChange={(event) =>
                      handleAddonDataChange({
                        target: {
                          name: "mandatory",
                          value: event.target.checked,
                        },
                    })
                    }
                    color="primary"
                  />
                }
                label={
                  <MaterialTypography variant="caption" fontWeight="bold">
                    {addonData?.mandatory ? "Yes" : "No"}
                  </MaterialTypography>
                }
                sx={{ marginLeft: 0 }}
              />
            </Grid>

            <Grid size={{ xs: 6, sm: 2 }}>
              <MaterialBox>
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Active
                </MaterialTypography>
              </MaterialBox>
              <FormControlLabel
                control={
                  <Switch
                    name="isActive"
                    checked={addonData.isActive}
                    onChange={(event) =>
                      handleAddonDataChange({
                        target: {
                          name: "isActive",
                          value: event.target.checked,
                        },
                    })
                    }
                    color="primary"
                  />
                }
                label={
                  <MaterialTypography variant="caption" fontWeight="bold">
                    {addonData?.isActive ? "Yes" : "No"}
                  </MaterialTypography>
                }
                sx={{ marginLeft: 0 }}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Description
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="description"
                placeholder="eg. Enter Description"
                multiline
                rows={3}
                value={addonData.description}
                onChange={handleAddonDataChange}
                error={addonData.descriptionStatus === "error" ? true : false}
                success={
                  addonData.descriptionStatus === "success" ? true : false
                }
              />
              {addonData.descriptionStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Description should be maximum 100 characters long and can
                    contain only alphabets
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>
          </Grid>
        </MaterialBox>
      </CardContent>
      <MaterialBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <MaterialButton
          sx={{ m: 2 }}
          variant="outlined"
          color="dark"
          onClick={() => {
            navigate("/general-master/general-addon");
          }}
        >
          Cancel
        </MaterialButton>
        <MaterialButton
          sx={{ m: 2 }}
          variant="gradient"
          color="dark"
          disabled={!checkAllFields()}
          onClick={handleSubmit}
        >
          Submit
        </MaterialButton>
      </MaterialBox>
    </>
  );
};
